<template>
  <div id="positionSelect" style="display:flex;flex:1;flex-direction: column;">
    <Layout id="AppViewport">
      <Content class="app-body">
        <div class="app-ploter-main" v-loading="this.loading" element-loading-text="加载中">
          <div class="app-ploter-main-body">
            <div ref="ploterWrap" class="app-editor-ploter-wrap positionlist">
              <div class="app-editor-ploter-navigation" style="width:100%;">
                <div class="app-editor-ploter-navigation">
                  <div class="ploter-navigation-list">
                    <el-button v-for="data in zgtableData" style="width: 4.375rem;" :key="data.uuid" @click="getStage(data.uuid,$event)"
                      size="small" type="primary" v-bind:class="{'selected': data.uuid==zguuid }">{{data.zgmc}}</el-button>
                  </div>
                  <div class="ploter-navigation-tools">
                    <div class="ploter-navigation-tools-selected"
                    :class="{'ploter-navigation-tools-selected-ENG':isENG}" >
                      <el-button size="small" type="danger" v-for="data1 in yxzwData" :key="data1.uuid" icon="el-icon-delete"
                        id="closebtn" @click="handlerDel($event,data1.uuid)">{{data1.zwh}}</el-button>
                    </div>
                    <div class="ploter-navigation-tools-exp">
                      <!-- <el-button icon="el-icon-view" size="small" type="success"
                        @click="isViewAll = true">{{viewTitle}}</el-button> -->
                      <el-button icon="el-icon-download" size="small" type="success" :loading="isExportDisabledPdf"
                        @click="handlerExport('pdf')">{{exptextpdf}}</el-button>
                      <el-button icon="el-icon-message" size="small" type="success" :loading="isExportDisabledMail"
                        @click="handlerExport('mail')">{{exptextmail}}</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 画布容器 -->
            <div class="app-ploter-main-canvas" ref="plotStage"></div>
            <div class="app-ploter-main-mask"></div>
          </div>
        </div>
        <ComponentsBusinessShape @evt_stage_element_remove="doShapeDelete" />
      </Content>
      <appPloterWidgetMove class="fx"></appPloterWidgetMove>
      <AppPloterWidgetScale v-if="stage" :stage="stage" @evtStageCfgChanged="onStageCfgChanged" @evtStageScaleChanged="onStageScaleChanged"
        @evtStageScaleReset="onStageScaleReset" class="plusmin"></AppPloterWidgetScale>
    </Layout>
    <el-dialog :title="viewTitle" :visible.sync="isViewAll" width="30%" >
      <el-image :src="vsrc" :preview-src-list="[vsrc]" style="width: 100%; height: 400px;" >
       </el-image>
    </el-dialog>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex";
  import drawLib from "@/views/exhibition/ploter/draw";
  import plotundo from "@/plugins/plotundo";
  import {
    exitPlotTool,
    deleteShape
    // ,pasteShape
  } from "@/views/exhibition/ploter/draw/utils";
  import {
    prepareStageData,
    prepareStageElements,
    getShapeOnStage,
    clearShapeStyle
  } from "@/views/exhibition/ploter/draw/stage";
  import {
    Base64
  } from "js-base64";
  import {
    deepClone,getSrc
  } from "@/common/ploter/utils";
  // 共通组件
  import componentsBusinessShape from "@/components/ploter/businessShape";
  // 标绘组件
  import appPloterBBarMessage from "@/views/exhibition/ploter/bbar/Message";
  import appPloterBBarCoordinate from "@/views/exhibition/ploter/bbar/Coordinate";
  import appPloterBBarStageAttr from "@/views/exhibition/ploter/bbar/StageAttr";
  // widget
  import appPloterWidgetScale from "@/views/exhibition/ploter/widget/Scale";
  import appPloterWidgetMove from "@/views/exhibition/ploter/widget/Move";
  import JsPDF from 'jspdf';

  export default {
    name: "AppPloterMain",
    components: {
      ComponentsBusinessShape: componentsBusinessShape,
      AppPloterBBarMessage: appPloterBBarMessage,
      AppPloterBBarCoordinate: appPloterBBarCoordinate,
      AppPloterBBarStageAttr: appPloterBBarStageAttr,
      AppPloterWidgetScale: appPloterWidgetScale,
      AppPloterWidgetMove: appPloterWidgetMove
    },
    data() {
      return {
        vsrc:'',
        viewTitle:"展馆预览",
        isViewAll:false,
        isstart: false, //选展位是否开始
        isBoothStart: false,
        query: this.$route.query, //上个路由页面传过来的数据
        currentBusinessData: {}, //当前展位数据
        currentUuid: "",
        zguuid: "",
        zgmc: "",
        zgtableData: null,
        yxzwData: [],
        now: "",
        lastEl: null,
        lastEvent: null,
        //显示加载中样
        loading: false,
        currentUser: this.CONSTANT.currentUser,
        stage: null,
        currentPlotTool: null,
        currentPlotActiveItem: null,
        currentPasteItem: null,
        footer: {
          show: false
        },
        coordinateSystem: {
          system: "像素",
          x: 0,
          y: 0
        },
        ploterCfg: {
          readOnly: true,
          businessShape: {
            enable: true,
            requestLoop: 0 // 0为不轮询
          }
        },
        isExportDisabledPdf: false,
        isExportDisabledMail: false,
        baseUrl: window.config.baseUrl, //读取图片base路径
        isENG: false,
        exptextpdf: 'PDF导出',
        exptextmail: '邮件导出',
        handlerDelTip: '此操作将取消该展位选择, 是否继续？',
        handlerDelSuccess: '展位取消成功',
        handlerDelError: '展位取消失败',
        handlerExportTip: '展馆邮件导出需要重置位置，请重新点击"邮件导出"',
        doExportMailTip: '已将展馆图片发送到您当前账户绑定邮箱，请查收！',
        doExportMailTitle: '当前展馆导出',
        handlerBusinessShapeSelectedMsg: '展位选择未开启',
        handlerBusinessShapeSelectedOcupy: '展位已经被选，请重新选择',
        handlerBusinessShapeSelectedTipS: '您已选择展位',
        handlerBusinessShapeSelectedTipE: ' 是否继续选择此展位？',
        handlerBusinessShapeSelectedSure: '是否确定选择此展位?',
        handlerBusinessShapeSelectedSuccess: '展位选择成功',
        handlerBusinessShapeSelectedError: '展位选择失败',
        tips: '提示',
        attention: '注意',
        confirm: '确定',
        yes: '是',
        no: '否',
        timer: '',
        qyzwyx : {},
        yxzwbzzwgs : 0,
        yxzwsngdzw : 0,
        yxzwswgdzw : 0,

        dwData:{},//管理员划定的档位 add by yushch 20230106
        kxzwList: [],//可选展位list(用于判断标位不能跳着选) add by yushch 20230109
      };
    },
    computed: {
      ...mapGetters({
        wrapStageData: "wrapStageData",
        ploterConfig: "ploterConfig",
        stageElements: "stageElements",
        stageSize: "stageSize",
        componentsBusinessShapeData: "componentsBusinessShapeData"
      })
    },
    watch: {
      zguuid(val,old){
        this.vsrc = getSrc(val)
      }
    },
    created() {
      drawLib.initLocalSetting();
      window.wrapHandshake.$off("evtBusinessShapeSelected");
      window.wrapHandshake.$on(
        "evtBusinessShapeSelected",
        this.handlerBusinessShapeSelected
      )
    },
    mounted() {
      this.isStart()
      this.initDw();//查询管理员给展商划定的档位 //add  by yushch 2023/01/06
      this.getYxzwData()
      this.initZg()
      this.initLang()
      this.timer = setInterval(() => {
        this.refresh();
      }, window.config.booth.selectRefreshTime);
    },
    beforeDestroy() {
      clearInterval(this.timer);
      let ploterMainBody = document.querySelector(".content-main")
      if (ploterMainBody && ploterMainBody.style) {
        ploterMainBody.style.width = ""
        ploterMainBody.style.height = ""
      }

    },
    methods: {
      initLang() {
        if (this.query.lan == 'ENG') {
          this.isENG = true
          this.exptextmail = 'Email export'
          this.exptextpdf = 'PDF export'

          this.handlerDelTip = 'This operation will cancel the booth selection. Do you want to continue?'
          this.handlerDelSuccess = 'Booth selection cancelled'
          this.handlerDelError = 'Failed to cancel booth selection'
          this.handlerExportTip = 'The location of the exhibition hall email export needs to be reset. Please click "Email export" again'
          this.doExportMailTip = 'The exhibition hall picture has been sent to your current account binding email, please check'
          this.doExportMailTitle = 'Export of current exhibition hall'
          this.handlerBusinessShapeSelectedMsg = 'Booth selection not open'
          this.handlerBusinessShapeSelectedOcupy = 'Booth has been reserved, please reselect'
          this.handlerBusinessShapeSelectedTipS = 'You have selected booth'
          this.handlerBusinessShapeSelectedTipE = ' do you want to continue to select this booth?'
          this.handlerBusinessShapeSelectedSure = 'Are you sure you want to choose this booth?'
          this.handlerBusinessShapeSelectedSuccess = 'Booth selection successful'
          this.handlerBusinessShapeSelectedError = 'Booth selection failed'
          this.tips = 'tips',
          this.attention = 'attention',
          this.confirm = 'confirm',
          this.yes = 'yes',
          this.no = 'no'
          this.viewTitle = 'view'
        }
      },
      //选择展位是否开始
      isStart() {
        let me = this;
        me.$axios.post("/zwjbxx/isStart").then(
          function(res) {
            if (res.data) {
              me.isstart = res.data.isStart
              me.isBoothStart = res.data.isBoothStart
            }
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      //lxy 0225 开始
      //初始化当前页面
      initZg() {
        const me = this;
        //获取展馆列表
        let params = {
          'reserve2':1, //开启
          userid: me.currentUser.userid
        }
        me.$axios.post("/zgjbxx/doSearchDataListByVOWithRange",params).then(
          function(res) {
            me.zgtableData = res.data.result;
            for(let i in me.zgtableData){
              let d = me.zgtableData[i]
              if (me.query.uuid && me.query.uuid == d.uuid) {
                me.zguuid = me.query.uuid
                me.getStage(me.query.uuid);
                return
              }
            }
            if (me.zgtableData.length > 0) {
              me.zguuid = me.zgtableData[0].uuid
              me.getStage(me.zgtableData[0].uuid);
            }
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      refresh: function() {
        this.isStart();
        //更新已选展位数据
        this.getYxzwData();
        //定时只更新数据
        this.initBusinessData(this.zguuid);
        
      },
      //计算已选展位面积
      calcYxzwMj: function() {
        this.yxzwbzzwgs = 0
        this.yxzwsngdzw = 0
        this.yxzwswgdzw = 0
        for(var i in this.yxzwData){
          let data =  this.yxzwData[i]
          let zwh = data.zwh
          let zwlb = data.zwlb

          if(zwh.indexOf('OD')>-1){
            this.yxzwswgdzw += data.zwmj
          }else{
            if(zwlb == '标准展位' || zwlb == 'Standard booth'){
              this.yxzwbzzwgs += 1
            }
            if(zwlb == '光地' || zwlb == 'Raw space'){
               this.yxzwsngdzw += data.zwmj
            }
          }
        }
      },
      //已选展位
      getYxzwData: function() {
        const me = this;
        me.$axios.post("/zwjbxx/getSelectedPos").then(
          function(res) {
            if (res && res.data && res.data.result) {
              let data = res.data.result.dvo
              me.kxzwList=[];
              if (data && data.length > 0) {
                me.yxzwData = data;

                //add by yushch 20230109
                for(let i in data){
                  if(data[i].bottom)
                    me.kxzwList.push(data[i].bottom);
                  if(data[i].top)
                    me.kxzwList.push(data[i].top);
                  if(data[i].left)
                    me.kxzwList.push(data[i].left);
                  if(data[i].right)
                    me.kxzwList.push(data[i].right);
                }
                console.log(me.kxzwList);
                //end add 20230109
              }else{
                me.yxzwData = []
              }
              //me.qyzwyx = res.data.result.qyzwyxVO
            }
            me.calcYxzwMj()
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      handlerDel: function(event, uuid) {
        var el = event.currentTarget;
        this.$confirm(this.handlerDelTip, this.tips, {
            confirmButtonText: this.yes,
            cancelButtonText: this.no,
            type: "warning"
          })
          .then(() => {
            if (uuid) {
              var params = {
                uuid: uuid,
                reserve2: 0,
                ffmc: 'SELECT',
                zhjs: window.config.zhjs
              };
              const me = this;
              me.$axios.post("/zwjbxx/doCancelByVO", params).then(
                function(res) {
                  if (res.data.msg == "success") {
                    me.yxzwData = [];
                    me.getYxzwData();
                    var businessData = me.back2plot(res.data.result, me.query.lan, me.isBoothStart, me.yxzwData);
                    //需要新增
                    me.$store.dispatch("updateBusinessRecord", businessData);
                   
                    // me.$message({
                    //   message: me.handlerDelSuccess,
                    //   type: "success",
                    //   center: true
                    // });
                     me.$alert(me.handlerDelSuccess, '提示', {
                      confirmButtonText: '确定',
                      type: 'success'
                    });

                    el.style.display = "none";
                  } else {
                    var msg = res.data.msg;
                    if (msg) {
                       if(me.query.lan == 'ENG'){
                         msg = me.handlerDelError;
                       }
                       me.$message({
                         message: msg,
                         type: "error",
                         center: true
                       });
                    }
                  }
                }.bind(this),
                function(error) {
                  console.log(error);
                }
              );
            }
          })
          .catch(() => {});
      },
      handlerExport: function(type) {
        if (this.zguuid) {
          const me = this;
          var wrap = document.querySelector('.app-ploter-main')
          let left = wrap.scrollLeft
          //判断画布是否偏移
          if (left > 0) {
            me.$alert(this.handlerExportTip, {
              confirmButtonText: this.confirm,
              type: 'warning'
            });
            wrap.scrollTo(0, 0)
            return
          }
          if (type == 'pdf') {
            me.isExportDisabledPdf = true
            me.doExportPdf()
          } else {
            me.isExportDisabledMail = true
            me.doExportMail()
          }
          // var data = me.componentsBusinessShapeData
          // for (var i = 0; i < data.length; i++) {
          //   let plotdata = data[i]
          //   if(plotdata.status != 'allotted'){
          //     plotdata.status = "normal"
          //   }
          // }
          // me.$store.commit("updateBusinessShapeData", data);
          // //延时5秒，否则数据还没加载完便导出
          // setTimeout(() =>{
          //     me.doExport()
          // },2000);
        }
      },
      doExportPdf() {
        this.getHbPic64(true)
        this.isExportDisabledPdf = false
      },
      doExportMail() {
        const me = this;
        var pic64 = this.getHbPic64()
        var params = {
          uuid: this.zguuid,
          reserve1: pic64,
          zgmc: this.zgmc
        };

        me.$axios.post("/zgjbxx/doExportTp", params).then(
          function(res) {
            if (res.status == 200) {

              me.$alert(me.doExportMailTip, me.doExportMailTitle, {
                confirmButtonText: me.confirm,
                type: 'success'
              });
              //me.initBusinessData(me.zguuid)
              me.isExportDisabledMail = false
              //me.loading = false
            }
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      getHbPic64(isPdf) {
        //获取画布图片
        var canvasWrap = document.querySelector('.app-ploter-main-canvas')
        var kc = canvasWrap.querySelector('.konvajs-content')

        var canvas0 = kc.children[0]
        var canvas1 = kc.children[1]

        var canvas = document.createElement("canvas")
        var width = canvasWrap.clientWidth
        var height = canvasWrap.clientHeight
        canvas.width = width
        canvas.height = height - 30
        var ctx = canvas.getContext("2d")
        ctx.drawImage(canvas0, 0, 0) //带偏移量 ctx.drawImage(canvas0, left, 0)
        ctx.drawImage(canvas1, 0, 0)
        var fbw_img_data = canvas.toDataURL('application/pdf') //base64数据  application/pdf image/png

        if (isPdf && isPdf == true) {
          //pdf页面偏移
          var position = 0;
          var pageData = fbw_img_data
          var pdf = new JsPDF('', 'pt', 'a4');
          //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
          //当内容未超过pdf一页显示的范围，无需分页
          var contentWidth = canvas.width;
          var contentHeight = canvas.height;
          var pageHeight = contentWidth / 592.28 * 841.89;
          var leftHeight = contentHeight;
          var imgWidth = 595.28;
          var imgHeight = 592.28 / contentWidth * contentHeight;
          if (leftHeight < pageHeight) {
            pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight;
              position -= 841.89;
              //避免添加空白页
              if (leftHeight > 0) {
                pdf.addPage();
              }
            }
          }
          pdf.save(this.zgmc + '.pdf');
        } else {
          return fbw_img_data
        }
      },
      handlerBusinessShapeSelected(data) {
        var msg = "";
        if (this.currentUser.deptid != "ZSYH") {
          return;
        }
        //根据企业意向限制选择展位数量
        // if (this.qyzwyx) {
        //   let bzzwgs = this.qyzwyx.bzzwgs
        //   let sngdzw = this.qyzwyx.sngdzw
        //   let swgdzw = this.qyzwyx.swgdzw
        //   let boothType = data.boothType
        //   let area = data.area
        //   let zwh = data.code
        //   let tsxx = ''
        //   if ((boothType == "标准展位" || boothType == "Standard booth") ) {
        //     if(bzzwgs && parseFloat(bzzwgs) != 0){
        //       if(bzzwgs < this.yxzwbzzwgs +1){
        //         if(this.isENG){
        //           tsxx = 'Sorry, number of excess demand'
        //         }else{
        //           tsxx = '抱歉，您已选的标准展位个数已经超出报名时填报的展位需求意向中的标准展位个数'
        //         }
        //       }
        //     }else{
        //       if(this.isENG){
        //         tsxx = 'Sorry, standard Booth Requirement not filled in'
        //       }else{
        //         tsxx = '抱歉，您报名时填报的展位需求意向中未填写标准展位个数'
        //       }
        //     }
        //   }
        //   if (boothType == "光地" || boothType == "Raw space") {
        //     if(zwh.indexOf("OD")>-1){
        //       if(swgdzw && parseFloat(swgdzw) != 0){
        //         if(parseFloat(swgdzw)*1.3 < parseFloat(this.yxzwswgdzw) + area){
        //           if(this.isENG){
        //             tsxx = 'Sorry, 30% more than required area'
        //           }else{
        //             tsxx = '抱歉，您已选的室外光地展位面积已经超出报名时填报的展位需求意向中的室外光地展位面积30%'
        //           }
        //         }
        //       }else{
        //         if(this.isENG){
        //           tsxx = 'Sorry, outdoor Raw Space Booth Requirement not filled in'
        //         }else{
        //           tsxx = '抱歉，您报名时填报的展位需求意向中未填写室外光地展位面积'
        //         }
        //       }
        //     }else{
        //       if(sngdzw && parseFloat(sngdzw) != 0){
        //         if(parseFloat(sngdzw)*1.3 < parseFloat(this.yxzwsngdzw) + area){
        //           if(this.isENG){
        //             tsxx = 'Sorry, 30% more than required area'
        //           }else{
        //             tsxx = '抱歉，您已选的室内光地展位面积已经超出报名时填报的展位需求意向中的室内光地展位面积30%'
        //           }
        //         }
        //       }else{
        //         if(this.isENG){
        //           tsxx = 'Sorry, indoor Raw Space Booth Requirement not filled in'
        //         }else{
        //           tsxx = '抱歉，您报名时填报的展位需求意向中未填写室内光地展位面积'
        //         }
        //       }
        //     }
        //   }
        //   if(tsxx){
        //     let confirmTsxx = '确认'
        //     if(this.isENG){
        //       confirmTsxx = 'confirm'
        //     }
        //     this.$alert(
        //       '<span style="color:red"><h3>' + tsxx + '</h3></span>', {
        //         confirmButtonText: confirmTsxx,
        //         type: "error",
        //         dangerouslyUseHTMLString: true
        //       }
        //     )
        //     return;
        //   }

        // }

        if (!this.isstart) {
          this.$message({
            message: this.handlerBusinessShapeSelectedMsg,
            type: "warning",
            center: true
          });
          return;
        }
        if (data.status == 'disabled') {
          if(this.isENG){
            this.dwData.reserve1 = this.dwData.reserve1.replace("标准展位","Standard Booth ");
            this.dwData.reserve1 = this.dwData.reserve1.replace("室内光地","Indoor Raw Space Booth ");
            this.dwData.reserve1 = this.dwData.reserve1.replace("室外光地","Outdoor Raw Space Booth ");
            this.dwData.reserve1 = this.dwData.reserve1.replace("个","booth(s)");
            this.dwData.reserve1 = this.dwData.reserve1.replace("平方","m²");
            this.$alert(
              '<span style="color:red"><h3>The current booth is not available，You can choose ：' + this.dwData.reserve1 + '</h3></span>',
              this.attention, {
                confirmButtonText: this.confirm,
                type: "error",
                dangerouslyUseHTMLString: true
              }
            );
              tsxx = "Sorry, can't choose booth across pavilions"
          }else{
            this.$alert(
              '<span style="color:red"><h3>当前展位不可选，可选档位为：' +this.dwData.czlxmc +","+ this.dwData.reserve1 + '</h3></span>',
              this.attention, {
                confirmButtonText: this.confirm,
                type: "error",
                dangerouslyUseHTMLString: true
              }
            );
          }
          
          return;
        }
        else if (data.status != 'normal') {
          this.$alert(
            '<span style="color:red"><h3>' + this.handlerBusinessShapeSelectedOcupy + '</h3></span>',
            this.attention, {
              confirmButtonText: this.confirm,
              type: "error",
              dangerouslyUseHTMLString: true
            }
          );
          return;
        }
        if (this.yxzwData.length > 0) {
          var yxzwxx = "";
          let syzwh = '' //所有展位号
          let syzgid = '' //所有展馆id
          //光地数量
          let gdsl = 0
          let gdzwh = ''
          //标准展位数量
          let bwsl = 0
          let bwzwh = ''
          let zgh =  data.code.substr(0,2)
          let zwlb =  data.boothType

          for (var i = 0; i < this.yxzwData.length; i++) {
            if (i == 0) {
              yxzwxx += this.yxzwData[i].zwh;
            } else {
              yxzwxx += "," + this.yxzwData[i].zwh;
            }
            syzwh += "," + this.yxzwData[i].zwh;
            syzgid += "," + this.yxzwData[i].zgid;
            //限制选择展位数量
             if('标准展位' == this.yxzwData[i].zwlb || 'Standard booth' == this.yxzwData[i].zwlb){
               bwsl++
               bwzwh += "," + this.yxzwData[i].zwh;
             }
             if('光地' == this.yxzwData[i].zwlb || 'Raw space' == this.yxzwData[i].zwlb){
               gdsl++
               gdzwh += "," + this.yxzwData[i].zwh;
             }
          }
          msg = this.handlerBusinessShapeSelectedTipS + yxzwxx + this.handlerBusinessShapeSelectedTipE
          //限制选择展位数量和只能在统一展馆选择展位(固定数量)
          let tsxx =''
          if(bwsl>=this.dwData.maxNum && ('标准展位' == zwlb || 'Standard booth' == zwlb)){
            if(this.isENG){
                tsxx = 'More than '+ this.dwData.maxNum +'standard booths have been selected'
              }else{
                tsxx = '您的档位划分最多允许选择'+ this.dwData.maxNum +'个标准展位，目前已选择'+bwsl+'个'
              }
          }
          if(gdsl>=1 && ('光地' == zwlb || 'Raw space' == zwlb)){
            if(this.isENG){
                tsxx = 'More than 1 Raw Space booths have been selected'
              }else{
                tsxx = '光地展位最多允许选择1个，目前已选择'+gdsl+'个'
              }
          }
          //E1室外 和 E4室外 算一个展馆也就是说E1和E4可以同时选
          // if(syzwh.length>0 && syzwh.indexOf(zgh)<0 ){
          //   if(this.isENG){
          //     tsxx = "Sorry, can't choose booth across pavilions"
          //   }else{
          //     tsxx = '抱歉，不能跨展馆选择展位'
          //   }
          // }
          //E1室外 和 E4室外 算两个展馆，也就是说E1和E4不可以同时选
          if(syzgid.length>0 && syzgid.indexOf(data.stageUuid)<0){
            if(this.isENG){
              tsxx = "Sorry, can't choose booth across pavilions"
            }else{
              tsxx = '抱歉，不能跨展馆选择展位'
            }
          }
          //光地和标准展位只能选择一个分类
          if(gdsl>0 && "标准展位" == zwlb ||
            bwsl>0 && "光地" == zwlb){
            if(this.isENG){
              tsxx = "Sorry, only one booth type can be selected!"
            }else{
              tsxx = '抱歉，只能选择一个展位类别展位'
            }
          }
          // if(bwzwh.length>0 && bwzwh.indexOf(zgh)<0 && '标准展位' == zwlb
          //   || gdzwh.length>0 && gdzwh.indexOf(zgh)<0 && '光地' == zwlb){
          //   if(this.isENG){
          //       tsxx = 'Sorry, it is not allowed to select the same booth type across pavilions'
          //     }else{
          //       tsxx = '抱歉，不能跨展馆选择相同类别的展位'
          //     }
          // }


          //add by yushch 20230109 限制标位
          if("标准展位" == zwlb || "Standard booth" == zwlb){
            if(!this.kxzwList.includes(data.code)){
              if(this.isENG){
                tsxx = "Sorry, only continuous booth can be selected!"
              }else{
                tsxx = '抱歉，只能选择连续展位'
              }
            }
          }
          //end add 20230109

          if(tsxx){
              let confirmTsxx = '确认'
              if(this.isENG){
                confirmTsxx = 'confirm'
              }
              this.$alert(
                '<span style="color:red"><h3>' + tsxx + '</h3></span>', {
                  confirmButtonText: confirmTsxx,
                  type: "error",
                  dangerouslyUseHTMLString: true
                }
              )
              return;
          }
        } else {
          msg = this.handlerBusinessShapeSelectedSure
        }
        this.$confirm(msg, this.tips, {
            confirmButtonText: this.yes,
            cancelButtonText: this.no,
            type: "warning"
          })
          .then(() => {
            const me = this;
            var params = {
              uuid: data.uuid,
              reserve2: 2,
              ffmc: 'SELECT'
            };
            me.$axios.post("/zwjbxx/doUpdateByVO", params).then(
              function(res) {
                if (res.data.msg == "success") {
                  me.yxzwData.push(res.data.result);
                  me.calcYxzwMj();
                  //add by yushch 
                  if(data.boothType=='标准展位' || data.boothType=='Standard booth'){
                     me.pushKxzwList(res.data.result);
                  }
                 
                  //end add
                  var businessData = me.back2plot(res.data.result, me.query.lan, me.isBoothStart, me.yxzwData);
                  //需要新增
                  me.$store.dispatch("updateBusinessRecord", businessData);

                  me.$alert(me.handlerBusinessShapeSelectedSuccess, {
                    confirmButtonText: me.confirm,
                    type: 'success'
                  });
                } else {
                  var msg = res.data.msg;
                  if (msg) {
                    if(me.query.lan == 'ENG'){
                      if(msg == '你还未通过审核，审核通过后方可选展位'){
                        msg = "You haven't passed the system audit. You can choose booths after passing the audit"
                      }
                      if(msg == '展位已经被选，请重新选择'){
                        msg = me.handlerBusinessShapeSelectedOcupy
                      }
                      if(msg == '选择展位失败'){
                        msg = me.handlerBusinessShapeSelectedError
                      }
                      if(msg.startsWith('标准展位最多允许选择') ){
                        msg = 'More than 4 standard booths have been selected'
                      }
                      if(msg.startsWith('光地展位最多允许选择')){
                        msg = 'More than 2 Raw Space booths have been selected'
                      }
                      if(msg == '抱歉，不能跨展馆选择相同类别的展位！'){
                        msg = 'Sorry, it is not allowed to select the same booth type across pavilions'
                      }
                      if(msg == '抱歉，不能跨展馆选择展位！'){
                        msg = "Sorry, can't choose booth across pavilions"
                      }
                      if(msg == '抱歉，只能选择一个展位类别展位！'){
                        msg = "Sorry, only one booth type can be selected!"
                      }
                    }
                  }else{
                    msg = me.handlerBusinessShapeSelectedError;
                  }
                  var businessData = me.back2plot(res.data.result, me.query.lan, me.isBoothStart, me.yxzwData);
                  //需要新增
                  me.$store.dispatch("updateBusinessRecord", businessData);
                  me.$alert(
                    '<span style="color:red"><h3>' + msg + "</h3></span>",
                    me.attention, {
                      confirmButtonText: me.confirm,
                      type: "error",
                      dangerouslyUseHTMLString: true
                    }
                  );
                }
              }.bind(this),
              function(error) {
                console.log(error);
              }
            );
          })
          .catch(() => {});
      },
      //改变展馆
      changeZgSelected(uuid, event) {
        if (event) {
          //删除展位平面图点击进来的默认展馆选中样式
          this.$route.query.uuid = ''
          this.lastEvent = event;
          var el = event.currentTarget;
          if (!el && event.currentTargetRefresh) {
            el = event.currentTargetRefresh;
          }
          if (this.lastEl) {
            this.lastEl.style.background = "#0684E5";
            this.lastEl.disabled = false;
          }
          if (el) {
            this.lastEl = el;
            el.style.background = "#666666";
            el.disabled = true;
          }
        }
      },
      getStage(uuid, event) {
        this.loading = true
        this.changeZgSelected(uuid, event)
        const me = this;

        window.moftPloter = {};
        var params = {
          uuid: uuid
        };
        this.zguuid = uuid;
        me.$axios.post("/zgjbxx/doSearchHbMKListByVO", params).then(
          function(res) {
            if (res.data.result.zgjbxxVO) {
              var zgjbxx = res.data.result.zgjbxxVO
              var currentShapesData = res.data.result.zwmoJsonDatas;
              var currentAreaStage = zgjbxx.zgzwhbStr;
              var zgtpdz = zgjbxx.zgtpdz
              me.zgmc = zgjbxx.zgmc
              var path = me.baseUrl + 'upload/' + zgtpdz
              var currentAreaStageObj = JSON.parse(currentAreaStage);
              //处理图片
              var http = require('http');
              http.get(path, function(res) {
                var chunks = [];
                var size = 0;
                res.on('data', function(chunk) {
                  chunks.push(chunk);
                  size += chunk.length; //累加缓冲数据的长度
                });
                res.on('end', function(err) {
                  var data = Buffer.concat(chunks, size);
                  var base64Img = data.toString('base64');
                  currentAreaStageObj.children["0"].children[1].attrs._shapeCfg.style.mainShape.src =
                    `data:image/png;base64,${base64Img}`
                  currentAreaStage = JSON.stringify(currentAreaStageObj)
                  var stageRecord = {
                    stageData: currentAreaStage,
                    shapesData: currentShapesData,
                    uuid: params.uuid
                  };
                  me.$store.commit("updateStageData", stageRecord);
                  me.initPloter(currentAreaStage || null, currentShapesData || null);
                  plotundo.init();
                  //放大缩小系数调为1.0
                  window.wrapHandshake.$emit("evt_stage_scale_changed", {
                    scaleLevel: 1
                  });
                  me.doStageScaleReset();
                  me.initBusinessData(params.uuid);
                });
              });
            }
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      initBusinessData(zgid) {
        //this.isStart()
        const me = this;
        var params1 = {
          zgid: zgid,
          lan: me.query.lan,
          userid: me.currentUser.userid
        };
        this.loading = false
        me.$axios.post("/zwjbxx/doSearchListByVOBooth", params1).then(
          function(res) {
            var businessData = [];
            for (var i = 0; i < res.data.length; i++) {
              var plotdata = this.back2plot(res.data[i], me.query.lan, me.isBoothStart, me.yxzwData)
              

              //add by yushch 2023/01/06
              if(plotdata.status == 'normal'){//新建展位 匹配一下档位，如果档位不匹配把状态改成disabled
                //匹配展位类型
                if(me.dwData.zwlx == '1'){//标准展位
                    if(plotdata.boothType=='光地' || plotdata.boothType=='Raw space'){//把光地展位设置成disabled
                      plotdata.status = 'disabled'
                    }
                    //add by yushch 2023-03-02
                    if(me.dwData.minNum==1){
                      if(plotdata.isSpecial == '1'){//特殊标记3-4个标位档位的展位
                        plotdata.status = 'disabled'
                      }
                    }else{
                      if(plotdata.isSpecial != '1'){//特殊标记3-4个标位档位的展位
                        plotdata.status = 'disabled'
                      }
                    }
                    //end add 2023-03-02
                }else{//光地
                    if(plotdata.boothType=='标准展位' || plotdata.boothType=='Standard booth'){//把标准展位设置成disabled
                      plotdata.status = 'disabled'
                    }
                    if(plotdata.area < me.dwData.min || plotdata.area > (me.dwData.max + 0.99)){//把超出面积范围的设置成disabled
                      plotdata.status = 'disabled'
                    }
                }

                //add by yushch 20250315 加展品类型限制
                if(plotdata.czlx != null && plotdata.czlx != '' && plotdata.czlx != undefined){
                  if(plotdata.czlx != me.dwData.czlx){
                    plotdata.status = 'disabled'
                  }
                }
                //end add
              }
              //end add yushch


              businessData.push(plotdata);
            }
            me.$store.commit("updateBusinessShapeData", businessData);
          }.bind(this),
          function(error) {
            console.log(error);
          }
        );
      },
      initPloter(stageData, shapesData) {
        const me = this;
        me.$store.commit("updatePloterCongig", this.ploterCfg);
        if (!stageData) {
          if (me.stage) {
            const warn = confirm(
              "现在执行新建操作将放弃对当前画布做出的修改，\n点击确认按钮前请确认您的标绘成果已经保存。"
            );
            if (warn === true) {
              me.stage.destroy();
            }
          }
          const createCfg = me.ploterConfig.createCfg;
          if (createCfg) {
            if (createCfg.type === "img") {
              stageData = drawLib.createEmptyStageData({
                width: createCfg.width,
                height: createCfg.height,
                backgroundImage: createCfg.from
              });
              me.initStage(stageData, ".app-ploter-main-canvas");
            }
          } else {
            stageData = drawLib.createEmptyStageData();
            me.initStage(stageData, ".app-ploter-main-canvas");
          }
        } else {
          let stageDataObj = JSON.parse(stageData);
          stageDataObj.children[1].children = shapesData || [];
          me.initStage(stageDataObj, ".app-ploter-main-canvas");
        }
        if (!this.ploterConfig.readOnly) {
          me.footer.show = true;
        }
      },
      initStage(stageData, wrap) {
        const me = this;
        if (window.ploterStage) {
          window.ploterStage.destroy();
        }

        function onWindowReady() {
          if (window.innerWidth > 0) {
            const data = prepareStageData(stageData);
            me.$store.commit("updateStageSize", {
              width: data.attrs.width,
              height: data.attrs.height + 30
            });
            // 画布比窗口大，设置为窗口大小
            if (data.attrs.width >= window.innerWidth) {
              data.attrs.width = window.innerWidth;
              data.attrs.height = window.innerHeight;
            }
            const stage = Konva.Node.create(data, wrap);
            me.stage = stage;
            window.ploterStage = stage;
            //  stage 存到store
            me.$store.commit("updatePloterStage", stage);
            me.setStageLayout();
            drawLib.reloadShapes(stage);
            me.initStageEvent(stage);
          } else {
            setTimeout(() => {
              onWindowReady();
            }, 100);
          }
        }
        onWindowReady();
      },
      initStageEvent(stage) {
        const me = this;
        if (!this.ploterConfig.readOnly) {
          stage.on("mousedown", e => {
            const mouseButton = e.evt.button;
            const targetShape = e.target;
            const targetShapeName = targetShape.getAttr("name");
            // ===============
            // 事件转发部分
            // ===============
            // 如果鼠标左键落下处不是交互工具，
            // 那基本不是要标绘就是要激活或取消激活交互工具
            if (mouseButton === 0) {
              // 左键单击
              if (
                targetShapeName !== "shapeAnchor" &&
                targetShape.parent.className !== "Transformer"
              ) {
                // 如果当前有激活的标绘工具，
                // 那么所有在底图上的左键单击都是画图
                if (me.currentPlotTool) {
                  stage.fire("evt-draw", e);
                  // }
                } else {
                  // 如果当前没有激活的标绘工具，
                  // 那么所有在画布上的左键单击都是选取(除了画布本身)
                  if (targetShape.nodeType !== "Stage") {
                    if (
                      targetShape.getId() !== "stageBackgroundArea" ||
                      targetShape.getId() !== "stageBackgroundImg"
                    ) {
                      me.doSelectShape(targetShape);
                    }
                  }
                }
              }
            } else {
              // 右/中键单击
              // 如果鼠标右/中键落下，
              // 那就是要取消激活标绘工具和交互工具
              me.doExitPlotTool();
            }
          });
          stage.on("evt_stage_element_changed", event => {
            let stageData = event.target.toJSON();
            prepareStageElements(JSON.parse(stageData));
            window.focus();
          });
          const plotStageEl = me.$refs.plotStage.querySelector(
            ".konvajs-content"
          );
          plotStageEl.addEventListener("mousemove", e => {
            const point = stage.getPointerPosition();
            me.coordinateSystem.x = point.x;
            me.coordinateSystem.y = point.y;
          });
          plotStageEl.addEventListener("mouseout", e => {
            me.coordinateSystem.x = null;
            me.coordinateSystem.y = null;
          });
          // 键盘事件
          window.addEventListener("keydown", event => {
            // console.log('event', event)
            // if (event.keyCode === 46) { // del键：删除选中
            //     if (me.currentPlotActiveItem) {
            //         me.doShapeDelete(me.currentPlotActiveItem)
            //     }
            // } else
            if (event.keyCode === 27) {
              // ESC键：中断绘制
              stage.fire("evt-stop");
              me.currentPlotActiveItem = null;
              // } else if (event.keyCode === 67 && event.ctrlKey) { // Ctrl+C
              //     if (me.currentPlotActiveItem && me.currentPlotActiveItem.className === 'MoftArrowLine') {
              //         alert('当前元素不支持复制粘贴操作')
              //     } else {
              //         me.currentPasteItem = me.currentPlotActiveItem
              //     }
              // } else if (event.keyCode === 86 && event.ctrlKey) { // Ctrl+V
              //     if (me.currentPasteItem) {
              //         pasteShape(me.currentPasteItem)
              //     }
              // } else if (event.keyCode === 90 && event.ctrlKey) { // Ctrl+Z
              //     if (window.plotstack.canUndo()) {
              //         window.plotstack['undo']()
              //     } else {
              //         alert('无可撤销内容')
              //     }
              // } else if (event.keyCode === 89 && event.ctrlKey) { // Ctrl+Y
              //     if (window.plotstack.canRedo()) {
              //         window.plotstack['redo']()
              //     } else {
              //         alert('无可恢复内容')
              //     }
            }
          });
        }
        // 屏蔽画布上的浏览器右键菜单
        if (me.$refs.plotStage) {
          me.$refs.plotStage.oncontextmenu = function() {
            return false;
          };
        }

        // 浏览器调整大小后，重设画布布局
        window.addEventListener("resize", e => {
          //me.onWindowResize();
        });
        // 激活一下子窗口，以捕获window下事件
        window.focus();
      },
      onSelectFile() {
        this.$refs.loadInput.click();
      },
      onSelectedPlotFile(e) {
        const me = this;
        const file = e.target.files[0];
        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = e => {
            const content = e.target.result.replace("data:;base64,", "");
            const stageData = JSON.parse(Base64.decode(content));
            if (!stageData.attrs.mplot) {
              alert("文件无效，请选择.mplot后缀的云帆标绘文件");
              return;
            }
            if (me.stage) {
              const warn = confirm(
                "现在打开标绘文件将放弃对当前画布做出的修改，\n点击确认按钮前请确认您的标绘成果已经保存。"
              );
              if (warn === true) {
                me.initPloter(stageData);
              }
            }
            this.$refs.loadInput.value = "";
          };
          reader.readAsDataURL(file);
        } else {
          alert("您的浏览器版本太低，请升级。");
        }
      },
      onToolSelected() {
        var tool = this.area[0];
        if (this.stage) {
          this.stage.fire("evt-stop");
          this.currentPlotTool = tool;
          this.initPlotTool();
        }
      },
      onStageCfgChanged(cfg) {
        drawLib.applyStageCfg(this.stage, cfg);
      },
      onStageScaleChanged(value) {
        this.doStageScale(value);
      },
      onStageScaleReset() {
        this.doStageScaleReset();
      },
      onSelectShape(shapeUuid) {
        const me = this;
        const shape = getShapeOnStage(shapeUuid);

        if (shape) {
          me.doSelectShape(shape.findOne(".mainShape"));
        }
      },
      initPlotTool() {
        if (!this.currentPlotTool) return;
        const toolCfg = { ...deepClone(this.currentPlotTool)
        };
        const stage = this.stage;
        drawLib.initPlotTool(toolCfg, stage);
      },
      doShapeDelete(shape) {
        const stage = this.stage;
        const shapeWrap = shape.findAncestor(".shapeWrap");
        deleteShape(shape);
        stage.fire("evt_stage_element_changed", {
          changeType: "delete",
          element: shapeWrap
        });
        this.currentPlotActiveItem = null;
      },
      doExitPlotTool() {
        const me = this;
        const stage = me.stage;
        stage.fire("evt-stop");
        exitPlotTool(stage);
        me.currentPlotTool = null;
        me.currentPlotActiveItem = null;
      },
      doSelectShape(target) {
        const me = this;
        const targetWrap = target.findAncestor(".shapeWrap");
        const targetMain = targetWrap.findOne(".mainShape");
        targetMain.fire("evt-active", targetMain);
        me.currentPlotActiveItem = targetMain;
      },
      doStageScale(value) {
        const stage = this.stage;
        //let ploterMainBody = document.querySelector(".app-ploter-main-body");
        let ploterMainBody = document.querySelector(".content-main");
        // const ploterWrap = document.querySelector('.konvajs-content')
        const ploterWrapSize = {
          width: Math.round(this.stageSize.width * value),
          height: Math.round(this.stageSize.height * value)
        };
        ploterMainBody.style.width = ploterWrapSize.width + "px";
        ploterMainBody.style.height = ploterWrapSize.height + "px";
        stage.setAttrs({
          width: ploterWrapSize.width,
          height: ploterWrapSize.height
        })
        stage.scale({
          x: value,
          y: value
        });
        stage.draw();
        // stage.fire("evt_stage_scale_changed", {
        //   scaleLevel: value
        // });
        // lxy 修改20200302
        window.wrapHandshake.$emit("evt_stage_scale_changed", {
          scaleLevel: value
        });
        //this.setStageLayout()
      },
      doStageScaleReset() {
        const stage = this.stage;
        //let ploterMainBody = document.querySelector(".app-ploter-main-body");
        let ploterMainBody = document.querySelector(".content-main");
        // const ploterWrap = document.querySelector('.konvajs-content')

        ploterMainBody.style.width = this.stageSize.width + "px";
        ploterMainBody.style.height = this.stageSize.height + "px";
        stage.setAttrs({
          width: this.stageSize.width,
          height: this.stageSize.height
        })
        stage.scale({
          x: 1,
          y: 1
        });
        stage.draw();
        stage.fire("evt_stage_scale_changed", {
          scaleLevel: 1
        });
        //this.setStageLayout()
      },
      setStageLayout() {
        const me = this;
        // const plotStageEl = me.$refs.plotStage
        const stage = me.stage;

        let ploterMain = document.querySelector(".app-ploter-main");
        //let ploterMainBody = document.querySelector(".app-ploter-main-body");
        let ploterMainBody = document.querySelector(".content-main");

        ploterMainBody.style.width = me.stageSize.width + "px";
        ploterMainBody.style.height = me.stageSize.height + "px";
        window.ploterScroll = {
          top: ploterMain.scrollTop,
          left: ploterMain.scrollLeft
        };
        ploterMain.addEventListener("scroll", function() {
          let dx = ploterMain.scrollLeft;
          let dy = ploterMain.scrollTop;
          stage.container().style.transform =
            "translate(" + dx + "px, " + dy + "px)";
          stage.x(-dx);
          stage.y(-dy);
          stage.batchDraw();
          window.ploterScroll = {
            top: dy,
            left: dx
          };
        });
        // let wrapWidth = window.innerWidth
        // if (me.currentPlotActiveItem) {
        //     wrapWidth = window.innerWidth - 320
        // }

        // if (wrapWidth > stage.width()) {
        //     plotStageEl.setAttribute('data-layout-center', true)
        // } else {
        //     plotStageEl.removeAttribute('data-layout-center')
        // }
      },
      onWindowResize() {
        const stage = this.stage;
        stage.setWidth(window.innerWidth);
        stage.setHeight(window.innerHeight);
      },

      onBeforeSave() {
        const me = this;
        let ploterMain = document.querySelector(".app-ploter-main");
        ploterMain.scrollTo(0, 0);
        me.stage.x(0);
        me.stage.y(0);
        me.stage.fire("evt-stop");
        exitPlotTool(me.stage);
        me.currentPlotTool = null;
        me.currentPlotActiveItem = null;
        me.doStageScaleReset();
        me.stage.width(me.stageSize.width);
        me.stage.height(me.stageSize.height);
        clearShapeStyle();
      },
      // 发射画布数据
      emitSaveData() {
        const me = this;
        me.onBeforeSave();

        function checkFlags() {
          if (window.moftPloter.shapeFeatureChangeCount === 0) {
            let jsonData = me.stage.toJSON();
            const dataUrl = me.stage.toDataURL();
            const data = {
              stageUuid: me.wrapStageData.uuid,
              jsonData: jsonData,
              picData: dataUrl,
              businessData: me.componentsBusinessShapeData
            };
            window.wrapHandshake.emit("evtSaveDataReady", data);
          } else {
            setTimeout(() => {
              checkFlags();
            }, 300);
          }
        }
        checkFlags();
      },



      initDw:function(){
        let vm = this;
        vm.dwData = vm.currentUser.cfpadwmjfwVO;
        if(vm.dwData == null || vm.dwData == {} ){
          let params={
            userid: vm.currentUser.userid,
          }
          vm.$axios.post("/cfpadwmjfw/doFindByUserid", params).then(
            function(res) {
              if (res.data.result != null) {
                vm.dwData = res.data.result;
              }
            }.bind(vm),
            function(error) {
              console.log(error);
            }
          );
        }
        
      },
      pushKxzwList: function(yxzw){
        if(yxzw.top){
          this.kxzwList.push(yxzw.top);
        }
        if(yxzw.bottom){
          this.kxzwList.push(yxzw.bottom);
        }
        if(yxzw.left){
          this.kxzwList.push(yxzw.left);
        }
        if(yxzw.right){
          this.kxzwList.push(yxzw.right);
        }
       // console.log(this.kxzwList);
      }
    }
  };
</script>

<style lang="scss">
  @import "~@/assets/app.scss";

  #positionSelect {
    .el-button {
      margin-right: 10px;
    }

    .el-button+.el-button {
      margin-left: 0px;
      margin-right: 10px;
    }

    .fx {
      margin-top: 60px;
    }

    .plusmin {
      margin-top: 60px;
    }

    .content[data-v-57ee01a8] {
      overflow-y: hidden;
    }

    #menu-toggle-btn {
      right: -26px;
      transform: rotateY(180deg);
    }

    .app-editor {
      width: 960px;
      margin: 16px auto;
    }

    .app-editor-list-item {
      display: flex;
      flex-direction: column;
      float: left;
      width: 300px;
      height: 240px;
      margin: 10px;

      > {
        .ivu-card-extra {
          top: 8px;
          right: 8px;

          .ivu-btn-text {
            padding: 4px 8px;
          }

          .ivu-icon {
            font-size: 16px;
          }
        }

        .ivu-card-body {
          position: relative;
          flex: 1;
          padding: 8px;
          background-color: #fafafa;
        }
      }
    }

    .app-editor-list-item-add {
      text-align: center;

      >.ivu-icon {
        line-height: 140px;
        font-size: 80px;
        font-weight: bold;
      }
    }

    .app-editor-list-item-thumb {
      height: 100%;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
    }

    .app-editor-ploter-wrap {
      flex-direction: column;
      background-color: #666;
    }

    /* 展位选择右侧按钮样式 */
    .cancelbtn {
      border: 0px;
      height: 30px;
      line-height: 0px;
      background: rgb(243, 26, 55);
      color: #fff;
      margin: 0px 3px 5px 3px;
      // padding-left: 35px;
    }

    .app-ploter-tools-graphs-menu-item {
      height: 30px;
      line-height: 0px;
      background: #0684e5;
      color: #fff;
      margin: 5px 3px 5px 0px;
    }

    .selected {
      background: #666666;
    }

    .app-editor-ploter-navigation {
      margin-top: -10px;
      padding-top: 10px;
      height: 60px;
      position: fixed;
      z-index: 9999;
      display: flex;
      width: calc(100% - 800px);
      background-color: #fff;

      > {
        .ploter-navigation-list {
          flex: 1;
          line-height: 36px;
          font-size: 16px;
          //text-indent: 24px;
        }

        .ploter-navigation-tools {
          width: 45%;
          position: fixed;
          right: 30px;
        }
      }
    }

    .ploter-navigation-tools-selected {
      position: absolute;
      line-height: 36px;
      font-size: 16px;
      flex: 1;
      float: right;
      width: 350px;
      right: 190px;
    }
    .ploter-navigation-tools-selected-ENG {
      right: 222px !important;
    }

    .ploter-navigation-tools-exp {
      right: -20px;
      position: absolute;
      line-height: 36px;
      font-size: 16px;
      flex: 1;
      float: right;
    }

    .app-editor-ploter-iframe {
      display: block !important;
      flex: 1;
      border: none;
    }

    .app-editor-create-model>.file-name {
      margin-left: 16px;
    }

    .app-editor-cropper-model> {
      .ivu-modal-body {
        padding: 0;
      }

      .moft-cropper {
        height: 64vh !important;
      }
    }

    .positionlist {
      // height: 100%;
      overflow: hidden;

      -webkit-transition-duration: 0.3s;
      -moz-transition-duration: 0.3s;
      -o-transition-duration: 0.3s;
      -ms-transition-duration: 0.3s;
    }

    .imagez {
      float: left;
      width: 100px;
      height: 100px;
      padding: 5px;
    }

    .box-card {
      float: left;
      width: 130px;
      margin: 5px;
    }

    .box-cardz {
      float: left;
      width: 270px;
      margin: 5px;
    }

    .text {
      font-size: 14px;
    }

    .clearfix {
      font-weight: bold;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/exhibition/booth/select/PositionSelect.vue